import { serverApi } from "./serverApi";
import { Priority } from "../types/priorityTypes";

export const priorityService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getAllPriorities: build.query<Array<Priority>, string>({
      query: () => ({
        url: "/priority/all-priorities"
      })
    }),
  })
});

export const {
  useGetAllPrioritiesQuery,
} = priorityService;